import { fromJS } from 'immutable'

import {
  SELECT_STATE,
  SELECT_LOCATION,
  USER_DATA_VALID
} from './constants'



export const initialState = fromJS({
  state: {
    id: null,
    name: ''
  },
  location: {
    id: null,
    name: ''
  },
  user: {
    fromData: {},
    dataOk: false
  }
})


export default function reducer(state = initialState, action) {
  switch(action.type){
    case SELECT_STATE:
      return state.set('state', action.state)
    case SELECT_LOCATION:
      return state.set('location', action.location)
    case USER_DATA_VALID:
      return state.set('user', action.user)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/scenes/NewClient/reducer.js